
import BaseRadio from "@/components/base/BaseRadio.vue";
import { tripTypes } from "@/config/tripTypes";
import { DirectionEnum, ModeOfTravelEnum } from "@/models/enums";
import { useBookingStore } from "@/store/booking";
import { computed, defineComponent } from "vue";

export default defineComponent({
	components: { BaseRadio },
	setup() {
		const bookingStore = useBookingStore();

		const modeOfTravel = computed(() => bookingStore.getBooking.modeOfTravel);

		const tripType = computed({
			get(): DirectionEnum {
				return bookingStore.getBooking.tripType;
			},
			set(value: DirectionEnum) {
				bookingStore.setTripType(value);
				bookingStore.setRoutes(bookingStore.getBooking.modeOfTravel);

				if (bookingStore.getBooking.tripType === DirectionEnum.Outward) {
					bookingStore.clearReturnRoute();
				}
			},
		});

		return {
			tripTypes,
			modeOfTravel,
			tripType,
			ModeOfTravelEnum,
		};
	},
});
